import PropTypes from 'prop-types';
import React from 'react';
import { useReaconditionedContainer } from './hooks/useReaconditionedContainer';
import { ReaconditionedContainerStyle } from './ReaconditionedContainer.styles';

export const ReaconditionedContainer = ({ appCtx, productAttributes }) => {
  const hookData = useReaconditionedContainer({ appCtx, productAttributes });

  const { condition, messageText, showLink, reaconditionedLink, shouldRender } = hookData;

  if (!shouldRender) {
    return null;
  }

  return (
    <>
      <div className="reaconditioned-container">
        <div className="reacond-icon">
          <i className="icon-buysection-reacond">&nbsp;</i>
        </div>

        <div className="reacond-message">
          <div className="reacond-text-available">
            {messageText}
            <span>{condition.name}</span>.
          </div>
          {showLink && (
            <div className="reacond-link-container">
              <a target="_blank" href={reaconditionedLink} rel="noopener noreferrer" className="more-info">
                Conocer más
              </a>
              <i className="csicon-right">&nbsp;</i>
            </div>
          )}
        </div>
      </div>
      <style jsx>{ReaconditionedContainerStyle}</style>
    </>
  );
};

ReaconditionedContainer.propTypes = {
  appCtx: PropTypes.object.isRequired,
  productAttributes: PropTypes.object.isRequired,
};
